<template>
  <section class="flow">
    <div class="container">
      <a-typography-title :level="1">
        服务流程与分工
      </a-typography-title>
      <a-row v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)"
             class="box_step" :gutter="[20,20]">
        <a-col v-for="item in 4"
               :span="6">
          <div class="step">
            <p>
              <b>{{ item }}</b>
            </p>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="[20,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :xl="6">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.step }}
            </a-typography-title>
            <a-typography-title :level="4">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.text }}
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalFormCollection','demo')">
          预约咨询
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'consult_flow',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            step: '第一步',
            title: '服务申请',
            text: '客户向星汉未来申请咨询服务，双方就服务需求和目标达成一致。'
          },
          {
            step: '第二步',
            title: '需求沟通',
            text: '星汉未来针对客户需求进行系统调研、计划制定、架构设计、实施技术方案设计等一系列操作。\n' +
              '客户配合同步进行调研反馈、计划决策等操作。'
          },
          {
            step: '第三步',
            title: '订单支付',
            text: '客户按照协商价格支付相关费用。'
          },
          {
            step: '第四步',
            title: '咨询完成',
            text: '星汉未来输出《设计方案》和《实施方案》。双方就报告的内容达成一致，满足客户预期目标，即完成咨询。'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/consult/';

.flow {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: 0;
}

.box_step {
  overflow: hidden;
  position: relative;
  padding: 20px 0 30px;
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 45px, -5%, auto, -5%);
    margin: auto 0;
    .bg('@{image}line.png', 110%, 2px, true);
  }
  
  .step {
    position: relative;
    
    p {
      @wh: 50px;
      display: block;
      position: relative;
      width: @wh;
      height: @wh;
      margin: 0 auto;
      background-color: @color_white;
      border-radius: 50%;
      .shadow();
      
      b {
        display: block;
        .position();
        width: -20px+@wh;
        height: -20px+@wh;
        margin: auto;
        background-color: @color_6;
        border-radius: 50%;
        .font(center, -20px+@wh, @color_white, @font_5, true);
      }
    }
  }
}

.item {
  position: relative;
  min-height: 305px;
  padding: 20px 20px;
  background: @color_white;
  border-radius: 8px;
  .shadow(0 0 15px fade(@color_black, 10));
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      &::before {
        background-position: -55px*(-1+@i) 0px;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before,
  &::after {
    content: '';
    display: block;
  }
  
  &::before {
    width: 55px;
    height: 55px;
    margin: 0 auto;
    .bg('@{image}flow_icon.png', 220px, 55px);
  }
  
  &::after {
    @wh: 20px;
    .position(absolute, -@wh*0.5, 0, auto, 0);
    width: @wh;
    height: @wh;
    margin: 0 auto;
    border: @wh*0.5 solid @color_white;
    .borderBox();
    .transform(rotate(45deg));
  }
  
  h4.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text_big, @color_12, @text_big, true);
  }
  
  h5.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text, @color_12, @text);
  }
  
  div.ant-typography {
    margin: 10px 0 0;
    .font(justify, @text+@line, @color_13, @text);
    .wordBreak();
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .ant-row {
    margin: 30px 0 0;
  }
  
  .item {
    min-height: 250px;
    
    &::after {
      display: none;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .flow {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    @scale: 0.5;
    min-height: auto;
    padding: 20px;
    
    .loop(@i) when (@i<=4) {
      &.i_@{i} {
        &::before {
          background-position: -55px*(-1+@i)*@scale 0px;
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &::before {
      width: 55px*@scale;
      height: 55px*@scale;
      .bg('@{image}flow_icon.png', 220px*@scale, 55px*@scale);
    }
    
    h4.ant-typography {
      margin: @margin_mo 0 0;
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    h5.ant-typography {
      .font(center, @text_mo, @color_12, @text_mo);
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>